import { QLD_MODELS } from '@/constants/compliance';

export default {
  data() {
    return {
      hideMenu: {
        header: ['Resource Hub'],
        name: [
          'Training & Events',
          'Compliance',
          'Shop',
        ],
      },
    };
  },
  methods: {
    filterMenus(menus) {
      const filtered = menus.filter(menu => {
        const shouldHideParent =
          this.hideMenu.name.includes(menu.name) || this.hideMenu.header.includes(menu.header);

        if (shouldHideParent) return false;

        if (Array.isArray(menu.items) && menu.items.length > 0) {
          menu.items = menu.items.filter(
            item => !this.hideMenu.name.includes(item.name)
          );

          return menu.items.length > 0;
        }

        return true;
      });
      return filtered;
    },
    getHiddenMenusByRegion(store) {
      const hideMenus = [];
    
      if (process.env.VUE_APP_REGION === 'AU') {
        const organizationClinicModels = store.getters['organization/selectedOrganizationActiveModels'];
    
        if (!organizationClinicModels.includes(QLD_MODELS.MODEL_3.toLowerCase())) {
          hideMenus.push('Dispense Request');
        }
      }
    
      return hideMenus;
    },
  },
};
